import React, { useEffect, useState } from "react";
import "./learning.css";
 
import axios from "axios";
import Slider from "react-slick";
import { ApiUrlDomain, ApiUrlDomainBlogImg } from "../../Configration/Configrationnew";
const Learning=()=> {
    const [blogsData,setBlogsdata]=useState([]);
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      };
      const BlogGet=async()=>{
        axios.get(`${ApiUrlDomain}/dynamicBlogs`,{
            method: 'GET',
            mode: 'no-cors',
            headers: {
              'Access-Control-Allow-Origin': '*'
            //   'Content-Type': 'application/json',
            },
            withCredentials: true,
            credentials: 'https://www.moneysukh.com',
          }).then((res)=>{
    setBlogsdata(res.data);
        }).catch((error)=>{
    console.log(error);
        });
      }
    useEffect(()=>{
        BlogGet();
    },[]);
    return (
        <>
            <section className="learngrow_section">
                <div className="container">
                    <div className="page_heading">
                        <h2><span>Start Learning, Start Growing</span></h2>
                        <p>
                            Master the fundamentals of investing in financial instruments like stocks, bonds, mutual funds, <br></br>and other investment options to develop your skills.
                        </p>
                    </div>
					<div className="learngrow_main">
                    <div className="learngrow_slider">
                            <Slider {...settings}>
                                {blogsData && blogsData.map((val,index)=> <div className="learngrow_group"> <div className="learngrow_panel">
                                    <img src={`${ApiUrlDomainBlogImg}/${val.imgurl}`} alt="img" />
                                    <h3>{val.title}</h3>
                                    <a href={val.redirecturl} className="readMore" target="_blank">Read More</a>
                                    </div></div>)}
                               
                                {/* <div className="learngrow_panel">
                                    <img src="https://learn.moneysukh.com/wp-content/uploads/2022/07/corporate-actions.png" alt="img" />
                                    <h3>How Corporate Actions impact Stock prices?</h3>
                                    <a href="https://learn.moneysukh.com/five-corporate-actions-and-its-impact-on-stock-prices/" target="_blank" className="readMore">Read More</a>
                                </div>
                                <div className="learngrow_panel">
                                    <img src="https://learn.moneysukh.com/wp-content/uploads/2022/06/mutual-fund.png" alt="img" />
                                    <h3>Reasons why people invest in Mutual funds?</h3>
                                    <a href="https://learn.moneysukh.com/reason-why-people-invest-in-mutual-funds/" target="_blank" className="readMore">Read More</a>
                                </div>
                                <div className="learngrow_panel">
                                    <img src="https://learn.moneysukh.com/wp-content/uploads/2022/06/mutual-fund.png" alt="img" />
                                    <h3>Reasons why people invest in Mutual funds?</h3>
                                    <a href="https://learn.moneysukh.com/reason-why-people-invest-in-mutual-funds/" target="_blank" className="readMore">Read More</a>
                                </div> */}
                                </Slider>
                        {/* <div className="col-sm-4 mt-20px">
                            <div className="learngrow_group">
                                <div className="learngrow_panel">
                                    <img src="https://learn.moneysukh.com/wp-content/uploads/2022/07/corporate-actions.png" alt="img" />
                                    <h3>How Corporate Actions impact Stock prices?</h3>
                                    <a href="https://learn.moneysukh.com/five-corporate-actions-and-its-impact-on-stock-prices/" target="_blank" className="readMore">Read More</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4 mt-20px">
                            <div className="learngrow_group">
                                <div className="learngrow_panel">
                                    <img src="https://learn.moneysukh.com/wp-content/uploads/2022/06/mutual-fund.png" alt="img" />
                                    <h3>Reasons why people invest in Mutual funds?</h3>
                                    <a href="https://learn.moneysukh.com/reason-why-people-invest-in-mutual-funds/" target="_blank" className="readMore">Read More</a>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
				</div>
            </section>
        </>
    );
}
export default Learning;